import React from "react";
import "./services.scss";
import { AdditionalServices } from "../../../constants/Home";

const Services = () => {
  return (
    <section id="additional-services-wrapper">
      <div className="additional-services">
        <p className="title">OUR SERVICES</p>
        <h2 className="heading">
          Additional <span>Services</span>{" "}
        </h2>
        <div className="row services">
          {AdditionalServices?.map((item) => {
            return (
              <>
                <div class="col-lg-4 col-md-6 services-item">
                  <div class="single-services text-center">
                    <div class="services-icon">
                      <img src={item?.image} alt="" />
                    </div>
                    <h5>{item?.title}</h5>
                    <p>{item?.description}</p>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
